module.exports = "/_next/static/images/OSPConstruction-769ee01b02fa5c2250ea0cb90819bd1f.webp";